import { NgClass } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	ViewEncapsulation,
} from '@angular/core';

import { SelectionCardBase } from '../selection-card-base';
import { SelectionCardInputComponent } from '../selection-card-input/selection-card-input';

@Component({
	selector: 'vp-selection-card-radio',
	imports: [NgClass, SelectionCardInputComponent],
	templateUrl: '../selection-card-base.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SelectionCardRadioComponent extends SelectionCardBase {
	readonly cardControlType = 'radio' as const;

	updateOptions(element: string): void {
		if (!element) {
			return;
		}

		// Set selected property of the clicked option to true, rest to false
		this.options.update((options) => {
			return options.map((option) => {
				return {
					...option,
					selected: option.inputId === element,
				};
			});
		});

		this.updateFormControl();
	}

	protected updateFormControl() {
		this.customFormControl().setValue(
			this.options().find((option) => option.selected)?.inputId,
		);
	}
}
